/* eslint-disable no-useless-escape */
export default {
  YES: '是',
  NO: '否',
  SAVE: '保存',
  RESET: '重置',
  APPLY: '应用',
  EXPORT_CONFIG: '导出配置',
  IMPORT_CONFIG: '导入配置',
  CHOOSE: '请选择',
  UPLOAD: '上传',
  CUSTOM: '自定义',
  EDIT: '编辑',
  COMPLETE: '完成',
  CANCEL: '取消',
  DISPLAY_NAME: '显示名称',
  ADD: '添加',
  EMPTY: ' ',
  PROCESSING: '处理中',
  EXPORTING: '导出中',
  IMPORTING: '导入中',
  ERRORCUST: '请上传正确的cust文件',

  CONFIG_SET: '配置管理',
  CONTACT_SET: '联系人设置',
  LAYOUT_SET: '布局设置',
  BG_SET: '背景设置',
  LANG_KEYBOARD_SET: '语言与键盘',
  SCREEN_SAVER_SET: '屏保设置',
  TASKBAR_SET: '任务栏设置',
  CALL_SET: '通话设置',
  AUTOSIZE_SET: '屏幕自适应设置',

  SYSTEM_MAINTENANCE: '系统维护',
  APP_SET: '应用设置',
  TOOL_SET: '小工具设置',
  SYSTEM_SET: '系统设置',
  PERI_SET: '外围设备设置',
  OTHER_SET: '其他设置',

  // 联系人设置
  EXT_XML: '请选择.xml文件。',
  EXT_XML_ETC: "请选择'.xml'或'.vcf'文件.",
  EXT_HTML: '请选择.html文件。',
  EXT_CSV: '请选择.csv文件。',
  EXT_VCARD: '请选择.vcf文件。',
  SELCODE: ' 你可以另选一种编码重试。',
  DOWNSUC: '下载成功!',
  DOWNFAIL: '下载失败!',
  DOWNMODEOFF: '下载模式已设成OFF',
  URLINVALID: '下载地址不合法，无效或者为空!',
  DOWNGUI: 'GUI正在使用!',
  DOWNFULL: '列表已满!',
  WILLFULL: '未进行该导入操作！该操作将致使总联系人数超出最大值：',
  DOWNPARSEFAIL: '解析失败!',
  FILEINVALID: '文件格式无效!',
  DOWNPROCESS: '下载正在处理!',
  IMPORTFAIL: '导入失败',
  IMPORTSUC: '导入成功!',
  IMPORTPROCESS: '导入正在处理!',
  FILE_TYPE: '文件类型',
  FILE_ENCODE: '文件编码',
  ENCODEERROR: '文件编码错误!您可以选择其他的文件编码再尝试一下。',
  NOCONTACTEXPORT: '无联系人可以导出!',
  DOWNSET: '下载/加载文件',
  FILESRC: '文件源',
  SRCINTERNET: '互联网',
  SRCLOCAL: '本地文件',
  CLEAR_OLD_LIST: '清除旧列表',
  CLEAR_OLD_LIST_MODE: '清除旧记录模式',
  CLEAR_ALL: '清除所有',
  DOWNDUPYES: '是',
  REPLACE_DUP: '替换重复的条目',
  REPLACE_DUP_MODE: '替换重复条目模式',
  REPLACE_BY_NAME: '根据名字替换',
  REPLACE_BY_NUMBER: '根据号码替换',
  KEEP_LOCAL_CONTACTS: '保留本地联系人',
  DOWNLOAD_MODE: '下载模式',
  DOWNLOAD_MODE_OFF: '关闭',
  SAVEFAV: '保存收藏夹到电脑',
  DOWNLOAD_SERVER: '下载服务器',
  DOWNLOAD_SERVER_EMPTY: '下载服务器不能为空！',
  DOWNNOW: '立即下载',
  DOWNLOAD: '下载',
  LOCALFILE: '本地文件',
  BROWSE: '浏览',
  DOWNBS: '下载BS联系人',
  SAVEPHONE: '保存电话薄到电脑',
  AUTO_DOWNLOAD_INTERFAL: '自动下载周期',
  IMEXPORT: '导入/导出',
  IMPORT: '导入',
  EXPORT: '导出',
  NAME: '用户名',
  PASSWORD: '密码',
  NONE: '无',
  HOUR: '{n}小时',
  HOURS: '{n}小时',
  LDAP_AND_CALLLOG: '联系人',
  SHOW_LDAP: '显示LDAP联系人',
  SHOW_CALLLOG: '显示本地通话记录',
  BSCALLTIME: 'BS通话记录间隔时间',
  HTTP_HTTPS_USERNAME: 'HTTP/HTTPS用户名',
  HTTP_HTTPS_PASSWORD: 'HTTP/HTTPS密码',
  ICE_CONTACT: 'ICE联系人',
  ICE_CONTACT_ERROR: '该联系人号码已存在',

  // 小工具设置
  DTMFLARGE: 'DTMF按钮大小',
  DTMFCOLOR: 'DTMF按钮颜色',
  SHOWIP: '显示IP地址',
  BIG: '大',
  MIDDLE: '中',
  SMALL: '小',
  RED: '红色',
  YELLOW: '黄色',
  GRAY: '灰色',
  BLUETOOTH: '蓝牙',
  LIGHT: '亮度',
  NODISTURB: '免打扰',
  LOCKSCREEN: '锁屏',

  // 任务栏设置
  DISABLE_TASKBAR: '禁用任务栏',
  TASK_TITLE1: '已选项',
  TASK_TITLE2: '可选项',
  WIFI: '无线网络',
  BT: '蓝牙',
  GS_DND: '勿扰模式',
  GS_VOICE: '声音',
  GS_AUDIO: '音频校准',
  GS_LOCK: '关屏幕',
  GS_AUTOANSWER: '自动应答',
  GS_TRANSFER: '呼叫转移',
  GS_HOTSPOT: '便携式热点',
  GS_EHS: 'RJ9耳机',
  GS_SCREENSHOT: '截屏',
  GS_NETWORK: '网络状态',
  TASKPROMPT: '拖拽图标可重新排序',
  TASKBOX_PROMPT1: '拖动图标可调整顺序，点击”-“可删减',
  TASKBOX_PROMPT2: '点击”+“添加到任务栏中',

  // 语言和键盘
  LANG_SET: '语言设置',
  LANG_SELECT: '选择语言',
  DEF_INPUT_METHOD: '默认输入法',
  CUSTOM_LANG: '自定义语言',
  CUSTOM_INPUT_METHOD: '自定义输入法',
  ANDROID_KEY: 'Android键盘（AOSP）',
  GOOGLE_PINYIN: '谷歌拼音输入法',
  // 屏保设置
  SCREEN_SAVER_TYPE: '屏保类型',
  SCREEN_SAVER_DEFAULT: '默认屏保',
  SCREEN_SAVER_CLOCK: '时钟屏保',
  SCREEN_SAVER: '屏保',
  SCREEN_SAVER_TIME: '屏保超时时间',
  SCREEN_SAVER_LCDOFF: '屏幕超时',
  SCREEN_SAVER_INTERVAL: '动画间隔时间',
  FORCE_ORIENTATION: '屏幕横屏',
  DEFAULT_DIR: '默认文件夹',
  LOCAL_IMG: '本地图片',
  NET_IMG: '网络图片',
  NET_IMG_ADDRESS: '网络图片地址',
  SECONDS: '{n}秒',
  MINUTE: '{n}分钟',
  MINUTES: '{n}分钟',
  NEVER: '从不',
  TYPE: '样式',
  DIGIT_CLOCK: '数字时钟',
  ANALOG_CLOCKS: '指针时钟',
  NIGHT_MODE: '夜间模式',
  // 布局设置
  DIALPAD_SHOW: '显示拨号盘界面',
  DIA_DESK_MANAGE: '禁用桌面管理',
  DIA_DESK_BTN: '禁用触摸按键',
  DIS_REMOVE_WIDGET: '禁用删除桌面小部件',
  APP_INSTALL_SCREEN: 'App安装屏',
  ADD_APP: '添加图标',
  ADD_WIDGET: '添加小工具',
  DEL_PAGE_WARN: '该界面有内容，无法删除',
  ADD_PAGE_WARN: '不能添加更多页面了',
  DEL_PAGE_WARN2: '该界面无法删除',
  AREA_WARN: '不在有效区内',
  NO_APP: '没有更多应用了',
  NO_WIDGET: '没有更多小工具了',
  OVERLAP_WARN: '请勿重叠',
  NOSPACE_WARN: '没有合适的位置',
  REAPTAPP_WARN: '该App已存在',
  NEW_FOLDER: '新增文件夹',
  UNNAMED_FOLDER: '未命名文件夹',
  CANNOT_REMOVE_FOLDER: '该文件夹有内容，无法删除',
  PRESENTATION: '演示',
  // 背景设置
  DISABLE_CHANGE_WALLPAPER: '禁止手动修改壁纸',
  ADD_BACKGROUND: '添加背景图片',
  IMG_ERROR: '请上传正确格式的文件(.jpg/.svg/.png/.jpeg/.bmp)',
  URL: '网址',
  UNNAME_BOOKMARK: '未命名书签',
  SC_NAME: '名称',
  SC_NAME_ERR_TIP: '请输入标签名称',
  URL_ERROR_TIP: '请输入正确格式的网址',

  // app
  OTHER: '其他',
  ACCONT22: '帐号(2X2)插件',
  ACCONT42: '帐号(4X2)插件',
  ACCONT43: '帐号(4X3)插件',
  ACCONTFIXED: '帐号(固定的)插件',
  FILEMANAGER: '文件管理器',
  BROWSER: '浏览器',
  DOWNLOADS: '下载内容',
  GALLERY: '图库',
  BLACKLIST: '黑名单',
  MESSAGE: '短信',
  PHONE: '电话',
  CALLHISTORY: '通话记录',
  CONTACTS: '联系人',
  SETTINGS: '设置',
  GSMARKET: 'GS应用市场',
  MARKET: 'GS应用市场',
  PNP: '智能配置',
  BROADSOFT_XMPP: 'BS-IM&P',
  MUSIC: '音乐',
  EMAIL: '电子邮件',
  DIAGNOSIS: '出厂设置',
  IP_LOCATION: 'IP定位',
  LYNC_SETUP: 'Lync设置导向',
  CALENDAR: '日历',
  CALCULATION: '计算器',
  CALCULATOR: '计算器',
  CLOCK: '时钟',
  BACKUP: '备份和恢复',
  CAMERA: '相机',
  CONF: '会议室',
  CONFERENCE: '会议室',
  FTP_SERVER: '文件传输服务',
  MPK: '可编程键',
  RECORDER: '录音管理',
  VOICEMAIL: '语音邮件',
  MPK61: 'MPK(6X1)插件',
  MPK41: 'MPK(4X1)插件',
  MPK21: 'MPK(2X1)插件',
  BOOKMARKS22: '书签(2X1)插件',
  DIGITAL_CLOCK: '数字时钟插件',
  ANALOG_CLOCK: '指针时钟插件',
  CALENDAR_APPLET: '日历插件',
  MUSIC_APPLET: '音乐插件',
  RSSNEWS_APPLET: 'RSS新闻插件',
  PHONE_WIDGET: '拨号窗口',
  WEATHER_FORECAST: '天气预报插件',
  WEATHER: '天气预报插件',
  SYSTEM_SETTINGS51: '系统设置(5X1)插件',
  SYSTEM_SETTINGS31: '系统设置(3X1)插件',
  ADD_THIRD_APP: '添加第三方应用',
  APK_NAME: 'apk名称',
  APK_ERROR: '无效的apk文件',
  TIMEOUT: '处理超时',
  APK_EMPTY: '显示名不能为空',
  XSI: 'BS XSI',
  IP_WIDGET: '系统状态',
  PAGE_MPK: '可翻页编程键',
  XMPP: 'BS-IM&P',
  STATE_DETECTION: '状态检测',
  BOOKMARK: '书签',

  UPLOAD_APK_ERROR: '请上传apk文件',
  BOOT_TYPE: '开机启动',
  BOOT: '开机启动',
  NOBOOT: '不启动',
  BOOT_NETWORK: '网络连接后启动',
  APP_AUTOLAUNCH: '无操作时自动启动',
  INTERVAL_WITHOUT_OPERATE: '无操作时间(秒)',
  SHOW_ICON: '显示应用图标',
  DEVICE_OWNER_CLASS: 'Device Owner Class',
  OWNER_CLASS_NONE: '无',
  // tooltips
  INSTRUCTIONS: '操作说明',
  CONFIG_SET_TIP:
    '启用/禁用设置,禁用后该设置项在此配置过程中不可操作,亦不会更新到配置文件中。',
  CONTACT_SET_TIP: '配置话机导入/导出/下载联系人的默认设置。',
  CONTACT_SET_TIP2: '配置默认紧急呼叫号码。',
  BACKGROUND_SET_TIP: '配置话机默认壁纸。',
  BACKGROUND_SET_TIP2: '可配置禁止用户更改壁纸。',
  LAYOUT_TIP_TITLE1: '设置桌面默认主页',
  LAYOUT_TIP1:
    '点击右侧数字黑框切换页面,点击左上角的home图标设置桌面默认主页。',
  LAYOUT_TIP_TITLE2: '更改桌面顺序',
  LAYOUT_TIP2: '选择桌面后,点击右上角的上下键更改桌面顺序。',
  LAYOUT_TIP_TITLE3: '增加/减少桌面',
  LAYOUT_TIP3: '点击黑框下方的“+”/“-”增加/减少桌面。',
  LAYOUT_TIP_TITLE4: '桌面布局',
  LAYOUT_TIP4: '选择桌面进行布局配置,包括主屏、应用、小部件及右侧导航栏。',
  LAYOUT_TIP42:
    '选择目标桌面,使用鼠标左键按住应用程序图标或小工具可将其从桌面拖拽到应用待选区或从应用待选区拖拽到桌面。',
  LAYOUT_TIP_TITLE5: '添加第三方应用程序',
  LAYOUT_TIP5:
    '点击“上传”,上传apk文件,具有图标和显示名称的第三方应用程序将显示在面板上。',
  LAYOUT_TIP_TITLE6: '添加文件夹',
  LAYOUT_TIP6:
    '点击“新增文件夹”，在选择的目标桌面上添加应用文件夹。使用鼠标左键按住应用程序图标可将其从桌面拖拽到文件夹中。',
  LAYOUT_TIP62:
    '双击打开文件夹，可查看应用，并编辑文件夹名。点击应用图标右上角的“×”，此应用将会被移除出文件夹，并按照从左到右、从上到下的顺序在桌面上显示。如若此桌面空间不足，则无法从文件夹中移除应用。',
  LAYOUT_TIP63: '注：当文件夹内应用少于2个时，配置到话机上不会生成文件夹。',
  SCREENSETTIP: '配置话机默认屏保功能。',
  LANGUAGE_SET_TIP: '配置话机默认语言及输入法。',
  TASKBAR_SET_TIP:
    '使用鼠标左键按住“已选项”中的图标进行拖拽可以对配置进行重新排序。',
  TASKBAR_SET_TIP2: '点击“已选项”中图标右上角的“-”移除该配置。',
  TASKBAR_SET_TIP3: '点击“已选项”中图标右上角的“+”添加该配置。',
  CALL_TIP_TITLE1: '添加显示菜单项',
  CALL_TIP1:
    '从左侧菜单中选择需要显示的菜单项,点击“加入右侧”按钮 ,最多选择4项。',
  CALL_TIP1_3350:
    '从左侧菜单中选择需要显示的菜单项,点击“加入右侧”按钮 ,最多选择2项。',
  CALL_TIP_TITLE2: '更换显示菜单项',
  CALL_TIP2:
    '从右侧菜单中选择需要隐藏的菜单项,点击“加入左侧”按钮,再从左侧菜单中选择需要显示的菜单项加入右侧即可。',
  CALL_TIP3:
    '长按某一菜单项,可以调整其在菜单栏中的显示位置。左右两侧菜单栏均支持拖动。',
  CALL_TIP4:
    '最多显示4个菜单项。当显示的菜单项不足4个时,将从左侧菜单栏中从上至下依次选择菜单项显示在通话界面。',
  CALL_TIP4_3350:
    '最多显示2个菜单项。当显示的菜单项不足2个时,将从左侧菜单栏中从上至下依次选择菜单项显示在通话界面。',
  ADJUST_SCREEN_TIP:
    '应用列表列出所有支持屏幕自适应功能的第三方应用，从列表中勾选出需要支持的应用即可。',
  // 新功能说明
  CLOSE: '关闭',
  NEW_FUNCTION: '新功能说明',
  NEW_FUNCTION1: '新功能说明',
  NEW_FUNCTION_TEXT1: '当前配置文件适用于',
  NEW_FUNCTION_TEXT2:
    '版本的话机,为确保配置文件的有效性,并避免配置出错,请确保终端话机的固件已升至',
  NEW_FUNCTION_TEXT3: '及以上版本!',
  NEW_FUNCTION_TEXT4: '新增通话设置配置页,增加通话界面按钮自定义功能',

  // callset
  CONFERENCE2: '会议',
  CALL_MUTE: '静音',
  CALL_KEYBOARD: '键盘',
  CALL_HOLD: '保持',
  CALL_VIDEO: '视频',
  RECORD: '录音',
  MEDIA_CHANNEL: '声音通道',
  CALL_TRNF: '转移',
  CALL_DETAIL: '通话详情',
  NEW_CALL: '新呼叫',
  SRTP: 'SRTP',
  CALL_CENTER: '呼叫中心',
  CALL_UCMROOM: 'UCM会议室',
  CALL_UCMMENU: 'UCM会议菜单',
  INVITE: '邀请',
  SOURCE_TITLE: '"更多"中的菜单',
  TARGET_TITLE: '显示的菜单',
  CALLSET_TRANSFER_ERROR: '最多可显示{n}项菜单',
  AVAILABLE: '可选',
  SELECTED: '已选',
  CALLSET_WARNING:
    '显示的菜单不足{n}项时，将从更多菜单中从上至下补全{n}项显示在通话界面',
  ONEWAY_TITLE: '单路通话界面功能设置',
  ONEWAY_PROMPT:
    '“显示的菜单”将直接呈现在通话界面中，默认显示{n}项。其他菜单默认隐藏在“更多”中',
  CON_TITLE: '会议室界面功能设置',
  CON_PROMPT:
    '“显示的菜单”将直接呈现在会议通话界面中，默认显示{n}项。其他菜单默认隐藏在“更多”中',
  EXPLAIN: '说明',

  // transfer
  ITEM: '项',
  APPLIST: '应用列表',

  UPLOAD_SUCCESS: '上传成功',

  WIRELESS_MIC: '无线麦克风',
  GUILDLINES: '使用指南',
  SCHEDULE: '预约会议',
  ENTERPRISE_DIR: '企业通讯录',
  CLOCK_APP: '时钟',

  SAVE_TO_GDMS: '保存至GDMS',
  SAVE_FAILED: '保存失败',
  SAVE_SUCC: '保存成功',
  SAVE_FAILED_33004: '保存失败, 文件已存在',
  EXPORT_FAILED: '导出失败',

  CONF_CONTROL: '会议控制',

  ONE_CLICK_CONFIG: '一键配置',

  DISABLE_FOCUS_MODE: '禁用专注模式',

  LDAP: 'LDAP',
  CALL_FORWARD: '呼叫转移设置',
  MULTICAST_LISTENING: '多播对讲监听',
};
